import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { _LiveTvChannelName } from "./optics";
import { _Channel } from "../video-page/optics/player";
const LiveTvPlayerView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const liveChannelDetailsM = Fold.preview(_LiveTvChannelName, data);
    const streamIDM = Fold.preview(_Channel, data);
    return {
        streamIDM,
        liveChannelDetailsM,
    };
};
const LiveTvPlayer = ({ liveChannelDetailsM, streamIDM, environment, }) => {
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(LiveTvPlayerView, { liveChannelDetailsM: liveChannelDetailsM, read: environment, streamIDM: streamIDM })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, LiveTvPlayer);

